import React, { useEffect } from 'react'
import Card from '../../../Base/Components/Card/Card'
import { Button } from 'primereact/button';
import { useState } from 'react';
import CalendarWeek from '../../../Base/Components/Form/CalendarWeek';
import { changePermosoRequisaCombustible, getRequisasCombusPendientesAutorizar, getRequisasNuevas } from '../../../API/Logistica/Combustible/RequisasCombustibleRequets';
import { getDateProduction } from '../../../Base/Services/FechasService';
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';
import DialogPassword from '../../../Base/Components/Dialog/DialogPassword/DialogPassword';
import { Tag, Toast } from 'primereact';
import { useRef } from 'react';
import { toastShow } from '../../../Base/Services/ToastService';
import { setTitlePage } from '../../../Base/Services/Config/ConfigService';

const RequisasCombustibleScreen = () => {

    const toast = useRef(null);

    const [data, setdata] = useState([]);
    const [dates, setDates] = useState([new Date(), new Date()]);
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState([]);
    const [password, setPassword] = useState('');
    const [showDialogPassword, setshowDialogPassword] = useState(false);
    

    const getInfo = async () => {
        setLoading(true);
        setSelected([]);
        setdata([]);
        const d = getDateProduction(dates)
        // const t = await getRequisasCombusPendientesAutorizar(0, { date1: d[0], date2: d[1] });
        const t = await getRequisasNuevas();
        console.log(t);
        setdata(t);
        setLoading(false);
    }


    const TipoTemplate = (rowData) => {
        switch (rowData.IdStatus) {
            case 3438:
                return <Tag severity='success' className='col-12' value={rowData.StatusName}  />
                break;
            case 3437:
                return <Tag severity='info' className='col-12' value={rowData.StatusName} />
                break;
            case 3614:
                return <Tag severity='warning' className='col-12' value={rowData.StatusName} />
                break;
            case 3436:
                return <Tag className='col-12' value={rowData.StatusName} />
                break;
            case 3439:
                return <Tag className='col-12' value={rowData.StatusName} style={{ background: '#CCC' }} />
                break;

            default:
                return <div>{rowData.StatusName}</div>
                break;
        }
    }


    const colums = [
        {
            headerName: 'Información General',
            children: [
                {
                    header: 'NoRequisa',
                    field: 'NoRequisa',
                    className: 'small',
                    frozen: true,
                },
                {
                    header: 'Estado',
                    field: 'EstadoDet',
                    className: 'small',
                    // Format: 'Template',
                    // body: TipoTemplate,
                    frozen: true,
                },
                {
                    header: 'Fecha',
                    field: 'Fecha',
                    Format: 'DateTime',
                },
            ]
        },
        {
            headerName: 'Solicita',
            children: [
                {
                    header: 'Area',
                    field: 'Area',
                    className: 'medium'
                },
                {
                    header: 'Coordinador',
                    field: 'UsuarioSolicita',
                    className: 'small'
                },
                {
                    header: 'Creado',
                    field: 'UsuarioCreo',
                    className: 'medium',
                },
                
            ]
        },
        {
            headerName: 'Vehiculo',
            children: [
                {
                    header: 'Tipo',
                    field: 'Tipo',
                    className: 'small',
                },
                {
                    header: 'Marca',
                    field: 'Marca',
                    className: 'small',
                },
                {
                    header: 'Placa',
                    field: 'Placa',
                    className: 'small',
                },
            ]
        },
        {
            headerName: 'Despacho',
            children: [
                {
                    header: 'Despacha',
                    field: 'AgenteDespacha',
                },
                {
                    header: 'Recibe',
                    field: 'AgenteRecibe',
                },
            ]
        },
        {
            header: 'Unidad',
            field: 'Unidad',
            frozen: true,
            alignFrozen: 'right',
            className: 'Xsmall',
        },
        // {
        //     header: 'Cantidad',
        //     field: 'CantidadSolicitada',
        //     frozen: true,
        //     alignFrozen: 'right',
        //     className: 'Xsmall',
        //     Format: 'Decimal',
        //     Sumary: 'sum'
        // },
        {
           headerName: 'Autorizaciones',
           children: [
               {
                   header: 'Solicita',
                   field: 'AutorizadoLogistica',
                   frozen: true,
                   alignFrozen: 'right',
                   className: 'Xsmall',
                   Format: 'Checkbox',
                   onChange: (e, {data}) => changePermiso(data)
               },
               {
                   header: 'Autoriza',
                   field: 'AutorizadoFinanzas',
                   frozen: true,
                   alignFrozen: 'right',
                   className: 'Xsmall',
                   Format: 'Checkbox',
                   onChange: (e, {data}) => changePermiso(data)
               },
            ]
        },
    ];


    const table = {
        Columns: colums,
        Data: data,
        loading: loading,
        selected: selected,
        setSelected: setSelected
    }

    const changePermiso = async(item) => {
        if(selected.length === 0){
            setSelected([item]);
        }
        setshowDialogPassword(true);
    }

    const authPermiso = async () => {
        const d = selected.map(e => e.IdRequisaD);
        let n = {
            IdRequisaDetalles: d.toString(),
            Password: password,
        }
       const t = await changePermosoRequisaCombustible(n);
       if (t?.length > 0) {
        if (t[0].ERROR < 0) {
            toastShow(toast, 'warn', t[0].MSG)
        } else {
            onHide()
            getInfo();
            toastShow(toast, 'success', 'Permisos Actualizados')
        }
    }
    }

    const onHide = () => {
       setshowDialogPassword(false);
       setPassword('');
    }

    useEffect(() => {
        getInfo()
        setTitlePage('Requisas de Combustible');
    }, [])


    return (
        <div>
            <Toast ref={toast}/>
            <DialogPassword
                display={showDialogPassword}
                selected={selected}
                loading={loading}
                onHide={onHide}
                password={password}
                setPassword={setPassword}
                showInput={true}
                authPermiso={authPermiso}
                authByUserOrRol={e => {}}

            />
            <Card
                titulo={<div style={{ display: 'flex', gap: 10 }}>
                    <h3>Requisas de combustible</h3>
                    <CalendarWeek
                        date={dates}
                        setDate={setDates}
                        loading={loading}
                        selectionMode='range'
                    />
                    <Button icon='pi pi-search' className="p-button-success" onClick={getInfo} />
                </div>}
                contenido={<div style={{ height: '90vh', paddingTop: 20 }}>
                    <AgGrid table={table} />

                </div>}
            />
        </div>
    )
}

export default RequisasCombustibleScreen